import { createAction, props } from '@ngrx/store';
import {Revotes} from '@emm/core/models/revotes.model';
import {SearchFilter} from '@emm/core/models/search-filter';

export enum MasterMenuSystemAction {
    LoadAll = '[Master Menu Management] Load All Master Menu Revotes',
    LoadAllSuccess = '[Management API] Load All Master Menu Revotes Success',
    LoadAllFailure = '[Management API] Load All Master Menu Revotes Failure',
    Select = '[Master Menu Management] Select Revote',
    LoadAllCategories = '[Master Menu Management] Load All Categories',
    LoadAllCategoriesSuccess = '[Management API] Load All Categories Success',
    LoadAllCategoriesFailure = '[Management API] Load All Categories Failure',
    LoadAllLocations = '[Master Menu Management] Load All Locations',
    LoadAllLocationsSuccess = '[Management API] Load All Locations Success',
    LoadAllLocationsFailure = '[Management API] Load All Locations Failure',
    OpenAddDialog = '[Master Menu Management] Open Add Revote Dialog',
    SearchRevote = '[Master Menu Management] Search Revote',
    Delete = '[Master Menu Management] Delete Revote',
    DeleteSuccess = '[Management API] Delete Revote Success',
    DeleteFailure = '[Management API] Delete Revote Failure',
}

export const MasterMenuSystemActions = {
    loadAll: createAction(MasterMenuSystemAction.LoadAll),
    loadAllSuccess: createAction(MasterMenuSystemAction.LoadAllSuccess, props<{ revotes: any[] }>()),
    loadAllFailure: createAction(MasterMenuSystemAction.LoadAllFailure, props<{ error: any }>()),
    loadAllCategories: createAction(MasterMenuSystemAction.LoadAllCategories, props<{ consumer: any }>()),
    select: createAction(MasterMenuSystemAction.Select, props<{ revote: Revotes }>()),
    loadAllCategoriesSuccess: createAction(MasterMenuSystemAction.LoadAllCategoriesSuccess, props<{ categories: any[] }>()),
    loadAllCategoriesFailure: createAction(MasterMenuSystemAction.LoadAllCategoriesFailure, props<{ error: any }>()),
    loadAllLocations: createAction(MasterMenuSystemAction.LoadAllLocations, props<{ consumer: any }>()),
    loadAllLocationsSuccess: createAction(MasterMenuSystemAction.LoadAllLocationsSuccess, props<{ locations: any[] }>()),
    loadAllLocationsFailure: createAction(MasterMenuSystemAction.LoadAllLocationsFailure, props<{ error: any }>()),
    openAddDialog: createAction(MasterMenuSystemAction.OpenAddDialog),
    searchRevote: createAction(MasterMenuSystemAction.SearchRevote, props<{ filter: SearchFilter }>()),
    delete: createAction(MasterMenuSystemAction.Delete, props<{ revote: any }>()),
    deleteSuccess: createAction(MasterMenuSystemAction.DeleteSuccess),
    deleteFailure: createAction(MasterMenuSystemAction.DeleteFailure, props<{ error: any }>()),
};

export const AsyncActions = {
    loadActions: [
        MasterMenuSystemActions.loadAll,
        MasterMenuSystemActions.loadAllCategories,
        MasterMenuSystemActions.loadAllLocations,
        MasterMenuSystemActions.delete
    ],
    successActions: [
        MasterMenuSystemActions.loadAllSuccess,
        MasterMenuSystemActions.loadAllCategoriesSuccess,
        MasterMenuSystemActions.loadAllLocationsSuccess,
        MasterMenuSystemActions.deleteSuccess
    ],
    errorActions: [
        MasterMenuSystemActions.loadAllFailure,
        MasterMenuSystemActions.loadAllCategoriesFailure,
        MasterMenuSystemActions.loadAllLocationsFailure,
        MasterMenuSystemActions.deleteFailure
    ],
};
